export default __webpack_public_path__ + "static/media/swipe-impact.7eb3c4a2.png";